import { ContractMode } from 'pricing/types';

export const isContractEditMode = (contractMode: ContractMode): boolean => {
  return contractMode === 'edit';
};

export const isContractViewMode = (contractMode: ContractMode): boolean => {
  return contractMode === 'view';
};

export const isContractCreateMode = (contractMode: ContractMode): boolean => {
  return contractMode === 'create';
};
